var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry-wake-tip",style:(_vm.tipCssVars)},[_c('p',{staticClass:"entry-wake-tip__text",domProps:{"innerHTML":_vm._s(_vm.messageHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }